<template>
    <div class="col-lg-12">
        <div class="card border-top-0">

            <div class="tab-content">
                <div class="tab-pane fade show active" id="profileTab" role="tabpanel">
                    <div class="card-body personal-info">
                        <form @submit.prevent="submitForm">
                            <div class="mb-4 d-flex align-items-center justify-content-between">
                                <h5 class="fw-bold mb-0 me-4">
                                    <span class="d-block mb-2">Hayvan Kartı:</span>
                                    <span class="fs-12 fw-normal text-muted text-truncate-1-line">Hayvan kartlarını
                                        buradan
                                        ekleyip düzenleyebilirsiniz.</span>
                                </h5>
                                <div class="d-flex gap-2">
                                    <button type="submit" class="btn btn-sm btn-light-brand">Kaydet</button>
                                    <a href="javascript:void(0);" class="btn btn-sm btn-light-brand">Kaydet ve Yeni
                                        Sayfa
                                        Aç</a>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Resim: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="mb-4 mb-md-0 d-flex gap-4 your-brand">
                                        <div
                                            class="wd-100 ht-100 position-relative overflow-hidden border border-gray-2 rounded">
                                            <!-- <img src="assets/images/avatar/1.png"
                                            class="upload-pic img-fluid rounded h-100 w-100" alt=""> -->
                                            <div
                                                class="position-absolute start-50 top-50 end-0 bottom-0 translate-middle h-100 w-100 hstack align-items-center justify-content-center c-pointer upload-button">
                                                <i class="feather feather-camera" aria-hidden="true"></i>
                                            </div>
                                            <input class="file-upload" type="file" accept="image/*">
                                        </div>
                                        <div class="d-flex flex-column gap-1">
                                            <div class="fs-11 text-gray-500 mt-2"># Upload your prifile</div>
                                            <div class="fs-11 text-gray-500"># Avatar size 150x150</div>
                                            <div class="fs-11 text-gray-500"># Max upload size 2mb</div>
                                            <div class="fs-11 text-gray-500"># Allowed file types: png, jpg, jpeg</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label for="animal-id-number" class="fw-semibold">Kimlik No: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="animal-id-number"
                                            v-model="animalIdNumber" placeholder="Kimlik No">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label for="animal-species" class="fw-semibold">Türü: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <select v-model="selectedSpecies" @change="fetchBreed" class="form-control"
                                            id="animal-species" data-select2-selector="animal-species">
                                            <option value="" disabled>Tür Seç</option>
                                            <option v-for="specie in species" :key="specie.id" :value="specie.id">
                                                {{ specie.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label for="animal-breed" class="fw-semibold">Cinsi: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <select v-model="selectedBreed" :disabled="breed.length === 0"
                                            class="form-control" id="animal-breed" data-select2-selector="animal-breed">
                                            <option value="" disabled>Irk Seç</option>
                                            <option v-for="item in breed" :key="item.id" :value="item.id">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label for="animal-age" class="fw-semibold">Yaşı: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="animal-age" v-model="animalAge"
                                            placeholder="Yaşı">
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label for="animal-gender" class="fw-semibold">Cinsiyeti: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <select class="form-control" id="animal-gender" v-model="animalGender"
                                            data-select2-selector="animal-gender">
                                            <option>Cinsiyeti</option>
                                            <option value="Erkek">Erkek</option>
                                            <option value="Dişi">Dişi</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label for="arrival-date" class="fw-semibold">Geliş Tarihi: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="arrival-date" v-model="arrivalDate"
                                            placeholder="Geliş Tarihi">
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label for="surrender-date" class="fw-semibold">Çıkış Tarihi: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="surrender-date"
                                            v-model="surrenderDate" placeholder="Çıkış Tarihi">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label for="owner-address" class="fw-semibold">Geldiği Adres: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="owner-address"
                                            v-model="ownerAddress" placeholder="Geldiği Adres">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label for="behaviour-pattern" class="fw-semibold">Davranış Şekli: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="behaviour-pattern"
                                            v-model="behaviourPattern" placeholder="Davranış Şekli">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center border border-solid border-gray-2 rounded pb-4">
                                <h5>Sahibinin</h5>
                                <div class="col-lg-1">
                                    <label for="owner-name" class="fw-semibold">Adı Soyadı: </label>
                                </div>
                                <div class="col-lg-3">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="owner-name" v-model="ownerName"
                                            placeholder="Adı Soyadı">
                                    </div>
                                </div>
                                <div class="col-lg-1">
                                    <label for="owner-phone" class="fw-semibold">Telefonu: </label>
                                </div>
                                <div class="col-lg-3">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="owner-phone" v-model="ownerPhone"
                                            placeholder="Telefonu">
                                    </div>
                                </div>
                                <div class="col-lg-1">
                                    <label for="owner-email" class="fw-semibold">E-Posta: </label>
                                </div>
                                <div class="col-lg-3">
                                    <div class="input-group">
                                        <input type="email" class="form-control" id="owner-email" v-model="ownerEmail"
                                            placeholder="E-Posta">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label for="description" class="fw-semibold">Diğer Husular: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" id="description" v-model="description"
                                            placeholder="Diğer Husular">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
export default {
    name: 'CreateAnimal',
    data() {
        return {
            species: [],
            breed: [],
            selectedSpecies: 0,
            selectedBreed: 0,
            animalIdNumber: "",
            animalAge: 0,
            arrivalDate: "",
            surrenderDate: "",
            animalGender: "",
            ownerName: "",
            ownerAddress: "",
            ownerPhone: "",
            ownerEmail: "",
            behaviourPattern: "",
            description: ""
        }
    },
    async mounted() {
        console.log('düzeldi');
        await this.fetchSpecies();
    },
    methods: {
        async fetchSpecies() {
            try {
                const response = await this.$axios.get('animal_species/?pagination=false');
                this.species = response.data;
                console.log(this.species);
            } catch (error) {
                console.log(error);
            }
        },
        async fetchBreed() {
            if (this.selectedSpecies === 0) {
                this.breed = [];
                return;
            }

            try {
                const response = await this.$axios.get('animal_breed?pagination=false&species=' + this.selectedSpecies);
                this.breed = response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async submitForm() {
            const formData = new FormData();
            formData.append('id_number', this.animalIdNumber);
            formData.append('species', parseInt(this.selectedSpecies));
            formData.append('breed', parseInt(this.selectedBreed));
            formData.append('age', this.animalAge);
            formData.append('arrival_date', this.arrivalDate ? dayjs(this.arrivalDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : "");
            formData.append('surrender_date', this.surrenderDate ? dayjs(this.surrenderDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : "");
            formData.append('gender', this.animalGender);
            formData.append('owner', this.ownerName);
            formData.append('owner_address', this.ownerAddress);
            formData.append('owner_phone', this.ownerPhone);
            formData.append('owner_email', this.ownerEmail);
            formData.append('behaviour_pattern', this.behaviourPattern);
            formData.append('description', this.description);
            console.log(formData);

            try {
                const response = await this.$axios.post('animal/', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                Swal.fire('Başarılı!', 'Kayıt tamamlandı.', 'success');
            } catch (error) {
                console.log(error);

                let errorMessage = Object.entries(error.response.data)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join('<br><br>');

                Swal.fire({
                    title: 'Hata!',
                    html: errorMessage, // HTML olarak göster (Satır atlamaları çalışsın)
                    icon: 'error',
                    confirmButtonText: 'Tamam'
                });
            }
        },

    }
}
</script>